import React, { useEffect } from 'react'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

function Init({ classes }) {
	return <div className={classes.homePage}></div>
}

export default withStyles(style)(Init)
